import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { getSignedAvatarUrl } from '../../../services/avatar'
import { getAvatarColor, getInitials } from './socialUtils'

export interface AuthorAvatarProps {
  name?: string | null
  avatarPath?: string | null
  size?: 'sm' | 'md'
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
}

const AuthorAvatar: React.FC<AuthorAvatarProps> = ({ name, avatarPath, size = 'md' }) => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      if (!avatarPath) {
        setAvatarUrl(null)
        return
      }
      const url = await getSignedAvatarUrl(avatarPath)
      if (!cancelled) setAvatarUrl(url)
    }
    load()
    return () => { cancelled = true }
  }, [avatarPath])

  return (
    <div
      className={clsx(
        'flex-shrink-0 rounded-full overflow-hidden flex items-center justify-center font-semibold',
        sizeClasses[size],
        !avatarUrl && getAvatarColor(name)
      )}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        getInitials(name)
      )}
    </div>
  )
}

export default AuthorAvatar
